import { translations } from '../../bundles/intl/de';

window.translations = translations;
